/**
 * Lost Collective — reveal-on-scroll utility
 *
 * Behaviour Spec BEHAV-001 / SE-1, PR-1, TR-1, FT-4:
 * Single IntersectionObserver, threshold 0.15, root-margin 0px 0px -10% 0px.
 * Adds `is-revealed` class to elements with [data-reveal] when intersecting.
 * Stagger children handled by [data-reveal-stagger] + CSS nth-child delays.
 * Trigger-once: each element is unobserved after firing.
 *
 * Reduced-motion: still fires (so content shows), but CSS collapses transition.
 */
(function () {
  'use strict';

  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  function init() {
    var targets = document.querySelectorAll('[data-reveal], [data-reveal-stagger]');
    if (!targets.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px',
    });

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
